








import Postmate from 'postmate'
import config from '@/config'
import firebase from 'firebase/compat/app'
import { Location } from '@/models'
import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api'
import { useEmitter } from '../../composition/useEmitter'
import { ProductRebillingService } from '../../../services'

export default defineComponent({
  setup(_, ctx) {
    const handshake = ref()
    const mediaFiles = ref()
    const maxUploadSize = ref({})
    /* we are taking default values as 4GB for videos and 100MB for other documents, Each document type size limit can be changed using this object
    Example: maxUploadSize.value = {
      video: 1000000000, <-- In bytes
      audio: 100000000,
      document: 100000000,
      image: 100000000
    }
    */
    const emitter = useEmitter()
    const route = ctx.root.$route
    const router = ctx.root.$router
    const store = ctx.root.$store
    const routerVersion = ref('v1')
    const { id: userId, email, platformLanguage } = store.state.user.user
    const { locations } = store.state.locations
    const locationData = locations.find(
      (x: Location) => x.id === route.params.location_id
    )

    const currentLocation = new Location(
      store.getters['locations/getCurrentLocation']
    )
    const locationSpecificLanguage = currentLocation?._data?.locale_settings?.platform

    const getUserPermission = () => {
      const permission = {
        contentAIEnabled: true,
      }
      if (store.state.user?.user?.permissions) {
        const permissions = store.state.user?.user?.permissions
        permission.contentAIEnabled =
          permissions.content_ai_enabled === false ? false : true
      }
      return permission
    }
    const isContentAiRebillingEnabled = async (companyId: string,locationId:string) => {
      const data = await ProductRebillingService.getByProductAndLocation(
        locationId,
        companyId,
        'contentAI'
      )
      if(data?.config?.optIn) return data?.config?.optIn
      return false
    }

    function getToken() {
      // @ts-ignore
      return firebase.auth().currentUser.getIdToken()
    }

    onMounted(() => {
      loadMicroApp()
      emitter.on('content-ai-generated-image', (id: string) => {
        if (id) {
          handshake.value?.then((child: any) => {
            child.call('selectedImageAIVariation', id)
          })
        }
      })
    })

    onUnmounted(() => {
      destroyApp()
    })

    function destroyApp() {
      handshake?.value?.then((child: any) => {
        child.destroy()
      })
    }

    async function loadMicroApp() {
      if (process.env.NODE_ENV === 'development') Postmate.debug = true

      const features = {
        contentAI: await isContentAiRebillingEnabled(
          locationData.company_id,
          locationData.id
        ),
      }

      handshake.value = new Postmate({
        container: mediaFiles.value as HTMLElement,
        url: `${config.mediaCenterAppUrl}`,
        name: 'media-center-app',
        model: {
          userId,
          email,
          apiKey: locationData.api_key,
          tokenId: await getToken(),
          companyId: locationData.company_id,
          altId: locationData.id,
          altType: 'location',
          hideHeader: true,
          allowedExtensions:['documents', 'image', 'video', 'audio'],
          maxUploadSize: maxUploadSize.value,
          userPermission: getUserPermission(),
          features,
          localeLanguage: platformLanguage ?? locationSpecificLanguage ?? 'en_US'
        },
      })
      handshake.value.then((child:any) => {
        child.on('close', (data: any) => {

         if(["contact_detail-v2","conversations-id-v2"].includes(route.name as string)){
          ctx.emit('exitML',{})
         } else {
          const routeName = 'media-settings-v2'
          router.push({ name: routeName })
         }
        })
        child.on('refresh-token', async () => {
          child.call('updated-token', await getToken())
        })

        child.on('attachment', (file: any) => {
          if (file) {
            ctx.emit('mediaSelected', file)
          }
        })

        child.on(
          'openImageGenerationForm',
          ({
            source,
          }: {
            source: 'media_library'
          }) => {
            emitter.emit('image-ai-generate', { source })
          }
        )
      })
    }

    return {
      mediaFiles,
      routerVersion
    }
  },
  beforeRouteEnter(to, from, next) {
      next((vm:any) => {
        vm.routerVersion = from?.meta?.router_version || 'v1'
        next()
      })
    },
})
